// Library imports
import React, { useState } from 'react';
import { styled } from '@mui/material/styles';

// Local imports
import Tab from 'components/Common/Tab';
import AccountsAndBalances from './AccountsAndBalances';
import AccountActivity from 'components/Dashboard/AccountActivity';
import { Divider } from '@mui/material';
import QRCodeGenerator from 'pages/QR/QRCodeGenerator';

// Styling
const StyledContainer = styled('div')({
    backgroundColor: '#F2F2F6',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
});

const ActionContainer = styled('div')({
    marginBottom: 16,
    padding: 22,
});

const InnerContainer = styled('div')({
    backgroundColor: 'white',
    padding: 4,
    marginTop: 10,
    width: '100%',
});

const DashboardScreen: React.FC = () => {
    const [tab, setTab] = useState('accountactivity'); // Set the default tab

    const setTabValue = (value: string) => {
        setTab(value);
    };

    return (
        <StyledContainer>
            <ActionContainer>
                <InnerContainer>
                    <Tab
                        tabs={[
                            { value: 'accountactivity', label: 'Account Activity' },
                            { value: 'accountandbalances', label: 'Accounts & Balances' },
                            { value: 'viewqrcode', label: 'View QR Code' },
                        ]}
                        tabValue={tab}
                        setTabValue={setTabValue}
                    />
                    <Divider />
                    <div>
                        {tab === 'accountactivity' ? (
                            <AccountActivity />
                        ) : tab === 'accountandbalances' ? (
                            <AccountsAndBalances />
                        ) : tab === 'viewqrcode' ? (
                            <QRCodeGenerator />
                        ) : null}
                    </div>
                </InnerContainer>
            </ActionContainer>
        </StyledContainer>
    );
};

export default DashboardScreen;
